import { Link } from "react-router-dom";
import { LayoutDashboard, Users, Store, Tag, BarChart3 } from "lucide-react";

const PORTALS = [
  {
    id: "erp",
    label: "SteelOne ERP Login",
    path: "/login",
    icon: LayoutDashboard,
    active: "border-[#C41E3A] bg-[#C41E3A]/8 text-[#C41E3A]",
    hover: "hover:border-[#C41E3A]/50 hover:bg-[#C41E3A]/5 hover:text-[#C41E3A]",
  },
  {
    id: "customer",
    label: "Customer Portal",
    path: "/portal/login",
    icon: Users,
    active: "border-sky-500 bg-sky-50 text-sky-600",
    hover: "hover:border-sky-400 hover:bg-sky-50 hover:text-sky-600",
  },
  {
    id: "vendor",
    label: "Vendor Portal",
    path: "/vendor-portal/login",
    icon: Store,
    active: "border-orange-500 bg-orange-50 text-orange-600",
    hover: "hover:border-orange-400 hover:bg-orange-50 hover:text-orange-600",
  },
  {
    id: "marketing",
    label: "Marketing Team",
    path: "/pricelist-view",
    icon: Tag,
    active: "border-amber-500 bg-amber-50 text-amber-600",
    hover: "hover:border-amber-400 hover:bg-amber-50 hover:text-amber-600",
  },
  {
    id: "odoo",
    label: "Odoo Reporting",
    path: "/odoo-reports/stock",
    icon: BarChart3,
    active: "border-emerald-500 bg-emerald-50 text-emerald-600",
    hover: "hover:border-emerald-400 hover:bg-emerald-50 hover:text-emerald-600",
  },
];

/**
 * Shared portal navigation strip shown on all login pages.
 * @param {string} active - "erp" | "customer" | "vendor" | "marketing" | "odoo"
 */
export function PortalNav({ active }) {
  return (
    <div className="pt-4 border-t border-slate-200 dark:border-border">
      <p className="text-[10px] text-slate-400 uppercase tracking-wider text-center mb-3 font-semibold">
        Other Portals
      </p>
      <div className="grid grid-cols-5 gap-1.5">
        {PORTALS.map(({ id, label, path, icon: Icon, active: activeCls, hover: hoverCls }) => {
          const isActive = active === id;
          return (
            <Link
              key={id}
              to={path}
              data-testid={`portal-nav-${id}`}
              className={`
                flex flex-col items-center gap-1.5 px-1 py-2.5 rounded-lg border
                transition-all text-center
                ${isActive
                  ? `border-2 ${activeCls} font-semibold`
                  : `border-slate-200 text-slate-400 ${hoverCls}`
                }
              `}
            >
              <Icon size={17} className="shrink-0" />
              <span className="text-[9px] font-semibold leading-tight">{label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
